import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellBase, ArsTableCellType } from "../interface";

/**
 * Type guard for ArsTableCellBase, which is the base type for all cell types in the table.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableCellBase, false otherwise
 */
export const isArsTableCellBase = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableCellBase<T> => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.annotationContent !== "string") return false;
  if (!Object.values(ArsTableCellType).includes(obj.cellType as ArsTableCellType)) return false;
  if (typeof obj.dataPath !== "string") return false;
  if (!isT(obj.displayContent)) return false;

  // Everything is good
  return true;
};
